@if (displayCustomerPrices$ | async) {
  <h4>{{ 'orderCost.orderSummary' | cxTranslate }}</h4>
  @if (cart) {
    <div class="cx-summary-partials">
      <div class="cx-summary-row">
        <div class="col-6 cx-summary-label">
          {{ 'orderCost.subtotal' | cxTranslate }}
        </div>
        <div class="col-6 cx-summary-amount">
          {{ cart.subTotal?.formattedValue }}
        </div>
      </div>
      @if (!cart.fromConfigurator && (cart.deliveryCostPending?.value === 0 || (cart.deliveryCostPending?.value > 0 && cart.orderValueMissing?.value === 0))) {
        <div class="cx-summary-row">
          <div class="col-6 cx-summary-label">
            {{
            'orderCost.shipping'| cxTranslate
            }}
          </div>
          <div class="col-6 cx-summary-amount">
            @if (cart.deliveryCostPending?.value === 0 || cart.orderValueMissing?.value > 0) {
              {{
              cart.deliveryCost?.formattedValue
              }}
            } @else {
              {{
              'orderCost.zero'| cxTranslate
              }}
            }
          </div>
        </div>
      }
      @if (!cart.fromConfigurator && cart.deliveryCostPending?.value > 0 && cart.orderValueMissing?.value > 0) {
        <div class="cx-summary-row">
          <div class="col-6 cx-summary-label">
            {{ 'orderCost.shippingPending' | cxTranslate }}
          </div>
          <div class="col-6 cx-summary-amount">
            {{ cart.deliveryCostPending?.formattedValue }}
          </div>
        </div>
      }
      @if (!cart.fromConfigurator) {
        <div class="cx-summary-row">
          <div class="col-6 cx-summary-label">
            {{ 'orderCost.salesTax' | cxTranslate }}
          </div>
          <div class="col-6 cx-summary-amount">
            {{ cart.totalTax?.formattedValue }}
          </div>
        </div>
      }
      @if (cart.totalExchangeTax && !cart.fromConfigurator) {
        <div class="cx-summary-row">
          <div class="col-6 cx-summary-label">
            {{ 'cartAdministration.orderCost.atTax' | cxTranslate }}
          </div>
          <div class="col-6 cx-summary-amount">
            {{ cart.totalExchangeTax?.formattedValue }}
          </div>
        </div>
      }
      <div class="cx-summary-row cx-summary-total">
        <div class="col-6 cx-summary-label">
          {{ 'orderCost.total' | cxTranslate }}
        </div>
        <div class="col-6 cx-summary-amount">
          {{ cart.totalPriceWithTax?.formattedValue }}
        </div>
      </div>
    </div>
  }
}
